// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'
import { bxAnaalyse } from '@/core/icons'

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import('@/views/user/Register')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import('@/views/user/RegisterResult')
      }
    ]
  },

  {
    path: '/404',
    redirect: '/'
  }
]

export const homeRouterMap = [
  {
    path: '/',
    name: 'home',
    component: BasicLayout,
    redirect: '/projects',
    meta: { keepAlive: true, icon: bxAnaalyse, permission: [ ] },
    children: [
      {
        path: '/projects',
        name: 'projects',
        component: PageView,
        meta: { title: '我的项目', keepAlive: false, icon: 'desktop', permission: [ 'user:item' ] },
        children: [
          {
            path: '/projects',
            name: 'projects',
            component: () => import('@/views/list/CardList'),
            meta: { title: '项目列表', keepAlive: false, icon: 'desktop', permission: [ 'user:item' ] }
          },
          {
            path: '/item/collection',
            name: 'itemcollection',
            component: () => import('@/views/list/ItemCollection'),
            meta: { title: '项目回收站', keepAlive: false, icon: 'ordered-list', permission: [ ] }
          }
        ]
      },
      {
        path: '/self',
        name: 'self',
        component: () => import('@/views/list/UserInfo'),
        meta: { title: '个人信息', keepAlive: false, icon: 'user', permission: [ 'user:inf' ] }
      },
      {
        path: '/file/management',
        name: 'filemanagement',
        component: () => import('@/views/list/FileList'),
        meta: { title: '文件管理', keepAlive: false, icon: 'ordered-list', permission: [ 'admin_data' ] }
      },
      {
        path: '/item/management',
        redirect: '/item/managemet/list',
        name: 'itemmanagement',
        component: PageView,
        meta: { title: '项目管理', keepAlive: false, icon: 'bank', permission: [ ] },
        children: [
          {
            path: '/item/management/list',
            name: 'itemlist',
            component: () => import('@/views/list/AdminItemList'),
            meta: { title: '项目列表', keepAlive: false, icon: 'ordered-list', permission: [ ] }
          }

        ]
      },
      {
        path: '/user/management',
        redirect: '/user/managemet/list',
        name: 'usermanagement',
        component: PageView,
        meta: { title: '用户管理', keepAlive: false, icon: 'team', permission: ['admin:user'] },
        children: [
        // 'admin:user'
          {
            path: '/user/management/list',
            name: 'userlist',
            component: () => import('@/views/list/AdminUserList'),
            meta: { title: '用户列表', keepAlive: false, icon: 'ordered-list', permission: [ 'admin:user' ] }
          },
          {
            path: '/user/management/new',
            name: 'createuser',
            component: () => import('@/views/list/CreateUser'),
            meta: { title: '新建用户', keepAlive: false, icon: 'user-add', permission: [ 'admin:user' ] }
          }
        ]
      },
      {
        path: '/role/management',
        name: 'rolemanagement',
        component: () => import('@/views/list/AdminRoleList'),
        meta: { title: '角色管理', keepAlive: false, icon: 'ordered-list', permission: [ 'admin:user' ] }
      }

    ]
  },

  {
    path: '*', redirect: '/404', hidden: true
  }
]

export const projectRouterMap =
[{
  path: '/project',
  name: 'project',
  component: BasicLayout,
  redirect: '/project/home',
  meta: { keepAlive: true, icon: bxAnaalyse, permission: [ ] },
  children: [
    {
      path: '/project/home',
      name: 'projecthome',
      component: () => import('@/views/Home'),
      hidden: true
    },
    {
      path: '/project/labels',
      redirect: '/project/labels/list',
      name: 'labels',
      component: PageView,
      meta: { title: '我的标注', keepAlive: false, icon: 'form', permission: [ 'user_label' ] },
      children: [

        {
          path: '/project/labels/list',
          name: 'labellist',
          // component: () => import('@/views/list/LabelList'),
          component: () => import('@/views/list/LabelList'),
          meta: { title: '标注列表', keepAlive: false, icon: 'ordered-list', permission: [ ] }
        },
        {
          path: '/project/labels/status',
          name: 'labelstatus',
          component: () => import('@/views/list/LabelStatus'),
          meta: { title: '标注统计', keepAlive: false, icon: 'line-chart', permission: [ ] }
        }
      ]
    },
    {
      path: '/project/data',
      name: 'data',
      redirect: '/project/data/list',
      component: PageView,
      meta: { title: '我的数据', keepAlive: false, icon: 'table', permission: [ 'user_collect' ] },
      children: [
        {
          path: '/project/data/list',
          name: 'datalist',
          component: () => import('@/views/list/DataList'),
          meta: { title: '数据列表', keepAlive: false, icon: 'ordered-list', permission: [ ] }
        },
        {
          path: '/project/data/add',
          name: 'adddata',
          component: () => import('@/views/form/AddData'),
          meta: { title: '数据采集', keepAlive: false, icon: 'file-jpg', permission: [ ] }
        }
      ]
    },

    {
      path: '/project/diagnose',
      redirect: '/project/diagnose/list',
      name: 'diagnose',
      component: PageView,
      meta: { title: '我的诊断', keepAlive: false, icon: 'solution', permission: [ 'user_diagnose' ] },
      children: [
        {
          path: '/project/diagnose/list',
          name: 'diagnoselist',
          component: () => import('@/views/list/DiagnoseList'),
          meta: { title: '诊断列表', keepAlive: false, icon: 'ordered-list', permission: [ ] }
        },
        {
          path: '/project/diagnose/add',
          name: 'adddiagnose',
          component: () => import('@/views/form/AddDiagnose'),
          meta: { title: '新建诊断', keepAlive: false, icon: 'file-jpg', permission: [ ] }
        }
      ]
    },
    {
      path: '/project/datas',
      name: 'datas',
      redirect: '/project/datas/list',
      component: PageView,
      meta: { title: '数据管理', keepAlive: false, icon: 'database', permission: [ 'admin_data' ] },
      children: [
        {
          path: '/project/datas/list',
          name: 'dataassign',
          component: () => import('@/views/list/DataAssignList'),
          meta: { title: '数据分配', keepAlive: false, icon: 'ordered-list', permission: [ ] }
        },
        {
          path: '/project/datas/status',
          name: 'datastatus',
          component: () => import('@/views/list/AdminUserStatisticsList'),
          meta: { title: '标注统计', keepAlive: false, icon: 'file-jpg', permission: [ ] }
        }
      ]
    },
    {
      path: '/project/center',
      redirect: '/project/center/members',
      name: 'projectcenter',
      component: PageView,
      meta: { title: '项目中心', keepAlive: false, icon: 'home', permission: [ 'admin_item' ] },
      children: [
        {
          path: '/project/center/members',
          name: 'projectmembers',
          component: () => import('@/views/list/MemberList'),
          meta: { title: '成员管理', keepAlive: false, icon: 'user', permission: [ ] }
        },
        {
          path: '/project/center/setting',
          name: 'projectsetting',
          redirect: '/project/center/setting/information',
          component: () => import('@/views/project/settings/Index'),
          meta: { title: '项目设置', keepAlive: false, icon: 'tool', permission: [ ] },
          hideChildrenInMenu: true,
          children: [
            {
              path: '/project/center/setting/information',
              name: 'informationsetting',
              component: () => import('@/views/project/settings/Information'),
              meta: { title: '项目信息', hidden: false, permission: [ ] }
            },
            {
              path: '/project/center/setting/labeltype',
              name: 'labeltypesetting',
              component: () => import('@/views/project/settings/LabelType'),
              meta: { title: '标注类型', hidden: true, permission: [ ] }
            },
            {
              path: '/project/center/setting/danger',
              name: 'dangersetting',
              component: () => import('@/views/project/settings/Danger'),
              meta: { title: '危险设置', hidden: true, permission: [ ] }
            },
            {
              path: '/project/center/setting/label',
              name: 'labelsetting',
              component: () => import('@/views/project/settings/Label'),
              meta: { title: '标注配置', hidden: true, permission: [ ] }
            },
            {
              path: '/project/center/setting/ndp',
              name: 'NDPIsetting',
              component: () => import('@/views/project/settings/NDPIsetting'),
              meta: { title: 'NDPI配置', hidden: true, permission: [ ] }
            },
            {
              path: '/project/center/setting/hospital',
              name: 'hospitalsetting',
              component: () => import('@/views/project/settings/HospitalList'),
              meta: { title: '数据来源', hidden: true, permission: [ ] }
            },
            {
              path: '/project/center/setting/model',
              name: 'modelsetting',
              component: () => import('@/views/project/settings/Model'),
              meta: { title: '诊断模型', hidden: true, permission: [ ] }
            }
          ]
        }
      ]
    }
  ]
},
{
  path: '*', redirect: '/404', hidden: true,
}
]

// {
//   path: '/',
//   name: 'index',
//   component: BasicLayout,
//   meta: { title: '首页' },
//   redirect: '/dashboard/workplace',
//   children: [
//     // dashboard
//     {
//       path: '/dashboard',
//       name: 'dashboard',
//       redirect: '/dashboard/workplace',
//       component: RouteView,
//       meta: { title: '仪表盘', keepAlive: true, icon: bxAnaalyse, permission: [  ] },
//       children: [
//         {
//           path: '/dashboard/analysis',
//           name: 'Analysis',
//           component: () => import('@/views/dashboard/Analysis'),
//           meta: { title: '分析页', keepAlive: false, permission: [  ] }
//         },
//         {
//           path: '/dashboard/monitor',
//           name: 'Monitor',
//           hidden: true,
//           component: () => import('@/views/dashboard/Monitor'),
//           meta: { title: '监控页', keepAlive: true, permission: [  ] }
//         },
//         {
//           path: '/dashboard/workplace',
//           name: 'Workplace',
//           component: () => import('@/views/dashboard/Workplace'),
//           meta: { title: '工作台', keepAlive: true, permission: [  ] }
//         }
//       ]
//     },
//     {
//       path: '/user',
//       name: 'user',
//       component: PageView,
//       redirect: '/user/list',
//       meta: { title: '成员管理', icon: 'table', permission: [ 'table' ] },
//       children: [
//         {
//           path: '/user/add-user',
//           name: 'AddUser',
//           component: () => import('@/views/form/AddUser'),
//           meta: { title: '添加成员', keepAlive: true, permission: [ 'form' ] }
//         },
//         {
//           path: '/user/user-list',
//           name: 'UserList',
//           component: () => import('@/views/list/UserList'),
//           meta: { title: '成员列表', keepAlive: true, permission: [ 'table' ] }
//         },
//       ]

//     },
//     // forms
//     {
//       path: '/form',
//       redirect: '/form/base-form',
//       component: PageView,
//       meta: { title: '表单页', icon: 'form', permission: [ 'form' ] },
//       children: [
//         {
//           path: '/form/base-form',
//           name: 'BaseForm',
//           component: () => import('@/views/form/BasicForm'),
//           meta: { title: '基础表单', keepAlive: true, permission: [ 'form' ] }
//         },
//         {
//           path: '/form/step-form',
//           name: 'StepForm',
//           component: () => import('@/views/form/stepForm/StepForm'),
//           meta: { title: '分步表单', keepAlive: true, permission: [ 'form' ] }
//         },
//         {
//           path: '/form/advanced-form',
//           name: 'AdvanceForm',
//           component: () => import('@/views/form/advancedForm/AdvancedForm'),
//           meta: { title: '高级表单', keepAlive: true, permission: [ 'form' ] }
//         }
//       ]
//     },

//     // list
//     {
//       path: '/list',
//       name: 'list',
//       component: PageView,
//       redirect: '/list/query-list',
//       meta: { title: '列表页', icon: 'table', permission: [ 'table' ] },
//       children: [
//         {
//           path: '/list/query-list',
//           name: 'QueryListWrapper',
//           hideChildrenInMenu: true, // 强制显示 MenuItem 而不是 SubMenu
//           component: () => import('@/views/list/TableList'),
//           meta: { title: '查询表格', keepAlive: true, permission: [ 'table' ] }
//         },
//         {
//           path: '/list/tree-list',
//           name: 'TreeList',
//           component: () => import('@/views/list/TreeList'),
//           meta: { title: '树目录表格', keepAlive: true, permission: [ 'table' ] }
//         },
//         {
//           path: '/list/edit-table',
//           name: 'EditList',
//           component: () => import('@/views/list/TableInnerEditList'),
//           meta: { title: '内联编辑表格', keepAlive: true, permission: [ 'table' ] }
//         },
//         {
//           path: '/list/user-list',
//           name: 'UserList',
//           component: () => import('@/views/list/UserList'),
//           meta: { title: '用户列表', keepAlive: true, permission: [ 'table' ] }
//         },
//         {
//           path: '/list/role-list',
//           name: 'RoleList',
//           component: () => import('@/views/list/RoleList'),
//           meta: { title: '角色列表', keepAlive: true, permission: [ 'table' ] }
//         },
//         {
//           path: '/list/system-role',
//           name: 'SystemRole',
//           component: () => import('@/views/role/RoleList'),
//           meta: { title: '角色列表2', keepAlive: true, permission: [ 'table' ] }
//         },
//         {
//           path: '/list/permission-list',
//           name: 'PermissionList',
//           component: () => import('@/views/list/PermissionList'),
//           meta: { title: '权限列表', keepAlive: true, permission: [ 'table' ] }
//         },
//         {
//           path: '/list/basic-list',
//           name: 'BasicList',
//           component: () => import('@/views/list/StandardList'),
//           meta: { title: '标准列表', keepAlive: true, permission: [ 'table' ] }
//         },
//         {
//           path: '/list/card',
//           name: 'CardList',
//           component: () => import('@/views/list/CardList'),
//           meta: { title: '卡片列表', keepAlive: true, permission: [ 'table' ] }
//         },
//         {
//           path: '/list/search',
//           name: 'SearchList',
//           component: () => import('@/views/list/search/SearchLayout'),
//           redirect: '/list/search/article',
//           meta: { title: '搜索列表', keepAlive: true, permission: [ 'table' ] },
//           children: [
//             {
//               path: '/list/search/article',
//               name: 'SearchArticles',
//               component: () => import('../views/list/TableList'),
//               meta: { title: '搜索列表（文章）', permission: [ 'table' ] }
//             },
//             {
//               path: '/list/search/project',
//               name: 'SearchProjects',
//               component: () => import('../views/list/TableList'),
//               meta: { title: '搜索列表（项目）', permission: [ 'table' ] }
//             },
//             {
//               path: '/list/search/application',
//               name: 'SearchApplications',
//               component: () => import('../views/list/TableList'),
//               meta: { title: '搜索列表（应用）', permission: [ 'table' ] }
//             }
//           ]
//         }
//       ]
//     },

//     // profile
//     {
//       path: '/profile',
//       name: 'profile',
//       component: RouteView,
//       redirect: '/profile/basic',
//       meta: { title: '详情页', icon: 'profile', permission: [ 'profile' ] },
//       children: [
//         {
//           path: '/profile/basic',
//           name: 'ProfileBasic',
//           component: () => import('@/views/profile/basic/Index'),
//           meta: { title: '基础详情页', permission: [ 'profile' ] }
//         },
//         {
//           path: '/profile/advanced',
//           name: 'ProfileAdvanced',
//           component: () => import('@/views/profile/advanced/Advanced'),
//           meta: { title: '高级详情页', permission: [ 'profile' ] }
//         }
//       ]
//     },

//     // result
//     {
//       path: '/result',
//       name: 'result',
//       component: PageView,
//       redirect: '/result/success',
//       meta: { title: '结果页', icon: 'check-circle-o', permission: [ 'result' ] },
//       children: [
//         {
//           path: '/result/success',
//           name: 'ResultSuccess',
//           component: () => import(/* webpackChunkName: "result" */ '@/views/result/Success'),
//           meta: { title: '成功', keepAlive: false, hiddenHeaderContent: true, permission: [ 'result' ] }
//         },
//         {
//           path: '/result/fail',
//           name: 'ResultFail',
//           component: () => import(/* webpackChunkName: "result" */ '@/views/result/Error'),
//           meta: { title: '失败', keepAlive: false, hiddenHeaderContent: true, permission: [ 'result' ] }
//         }
//       ]
//     },

//     // Exception
//     {
//       path: '/exception',
//       name: 'exception',
//       component: RouteView,
//       redirect: '/exception/403',
//       meta: { title: '异常页', icon: 'warning', permission: [ 'exception' ] },
//       children: [
//         {
//           path: '/exception/403',
//           name: 'Exception403',
//           component: () => import(/* ChunkName: "fail" */ '@/views/exception/403'),
//           meta: { title: '403', permission: [ 'exception' ] }
//         },
//         {
//           path: '/exception/404',
//           name: 'Exception404',
//           component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
//           meta: { title: '404', permission: [ 'exception' ] }
//         },
//         {
//           path: '/exception/500',
//           name: 'Exception500',
//           component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/500'),
//           meta: { title: '500', permission: [ 'exception' ] }
//         }
//       ]
//     },

//     // account
//     {
//       path: '/account',
//       component: RouteView,
//       redirect: '/account/center',
//       name: 'account',
//       meta: { title: '个人页', icon: 'user', keepAlive: true, permission: [ 'user' ] },
//       children: [
//         {
//           path: '/account/center',
//           name: 'center',
//           component: () => import('@/views/account/center/Index'),
//           meta: { title: '个人中心', keepAlive: true, permission: [ 'user' ] }
//         },
//         {
//           path: '/account/settings',
//           name: 'settings',
//           component: () => import('@/views/account/settings/Index'),
//           meta: { title: '个人设置', hideHeader: true, permission: [ 'user' ] },
//           redirect: '/account/settings/base',
//           hideChildrenInMenu: true,
//           children: [

//             {
//               path: '/account/settings/base',
//               name: 'BaseSettings',
//               component: () => import('@/views/account/settings/BaseSetting'),
//               meta: { title: '基本设置', hidden: true, permission: [ 'user' ] }
//             },
//             {
//               path: '/account/settings/security',
//               name: 'SecuritySettings',
//               component: () => import('@/views/account/settings/Security'),
//               meta: { title: '安全设置', hidden: true, keepAlive: true, permission: [ 'user' ] }
//             },
//             {
//               path: '/account/settings/custom',
//               name: 'CustomSettings',
//               component: () => import('@/views/account/settings/Custom'),
//               meta: { title: '个性化设置', hidden: true, keepAlive: true, permission: [ 'user' ] }
//             },
//             {
//               path: '/account/settings/binding',
//               name: 'BindingSettings',
//               component: () => import('@/views/account/settings/Binding'),
//               meta: { title: '账户绑定', hidden: true, keepAlive: true, permission: [ 'user' ] }
//             },
//             {
//               path: '/account/settings/notification',
//               name: 'NotificationSettings',
//               component: () => import('@/views/account/settings/Notification'),
//               meta: { title: '新消息通知', hidden: true, keepAlive: true, permission: [ 'user' ] }
//             }
//           ]
//         }
//       ]
//     },

//     // other
//     {
//       path: '/other',
//       name: 'otherPage',
//       component: PageView,
//       meta: { title: '其他组件', icon: 'slack', permission: [  ] },
//       redirect: '/other/icon-selector',
//       children: [
//         {
//           path: '/other/icon-selector',
//           name: 'TestIconSelect',
//           component: () => import('@/views/other/IconSelectorView'),
//           meta: { title: 'IconSelector', keepAlive: true, permission: [  ] }
//         }
//       ]
//     }
//   ]
// },
